var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 72",
    y: 4,
    width: 29,
    height: 22,
    rx: 2,
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 73",
    d: "M0 6C0 4.89543 0.895431 4 2 4H27C28.1046 4 29 4.89543 29 6V12L14.8824 17.8418C14.6375 17.9431 14.3625 17.9431 14.1176 17.8418L0 12V6Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 27.5,
    cy: 4.5,
    r: 4.5,
    fill: "#FFA692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaciones);
export default __webpack_public_path__ + "static/media/notificaciones.77ff2665e1e16888a90e1b07f1932a9d.svg";
export { ForwardRef as ReactComponent };